import { Injectable } from '@angular/core';
import { PaymentsPdfService } from '../../crud-quotation/payments/payments-pdf.service';
import { IStorageCompany } from 'src/app/@interfaces/company.interface';
import { CookieAuthService } from 'src/app/@shared/storage-variables/cookie-auth.service';
import { IPurchasesInvoices } from 'src/app/@interfaces/purchaseInvoice.interface';
import { PayPurchaseService } from './pay-purchase.service';
import { ImageConverseService } from '../../../services/files/imageConverse.service';
import { TranslateService } from '@ngx-translate/core';
import { PdfGeneratorService } from '../../../pdf-generator/pdf-generator.service';
import { GenerateContentPdfService } from '../../../services/files/generate-content-pdf.service';
import {
  PdfConfiguration,
  PdfContent,
} from 'src/app/@shared/interfaces/pdf.interface';

@Injectable({
  providedIn: 'root',
})
export class PayPurchasePdfService {
  companyObject = {} as IStorageCompany;
  companyName = '';
  constructor(
    private paymentsPdfService: PaymentsPdfService,
    private cookieAuthService: CookieAuthService,
    private payPurchaseService: PayPurchaseService,
    private imageConverseService: ImageConverseService,
    private translate: TranslateService,
    private pdfGeneratorService: PdfGeneratorService,
    private generateContentPdfService: GenerateContentPdfService,
  ) {}

  getAuthValues() {
    this.companyObject = this.cookieAuthService.getCompanyObject!;
    this.companyName = this.companyObject.name;
  }

  async createPaymentPurchasePdf(
    open: boolean,
    state: string,
    purchase: IPurchasesInvoices,
    image: any,
    paymentDescription: string,
    targetWindow: Window | null = null,
  ) {
    this.getAuthValues();
    const payments = await this.payPurchaseService.getPurchasePayments(
      purchase.id_invoice!,
    );
    const validations = this.generateContentPdfService.pdfPaymentValidations(
      payments,
      purchase,
    );
    if (!validations) {
      this.pdfGeneratorService.closePendingWindow(targetWindow);
      return;
    }
    const paymentType =
      this.generateContentPdfService.getPdfPaymentType(payments);
    const paymentElements =
      await this.generateContentPdfService.generatePdfPaymentItems(payments);
    const watermark = this.generateContentPdfService.createWatermark(state);
    const content = await this.createPurchasePaymentContent(
      image,
      purchase,
      paymentType,
      paymentDescription,
      paymentElements,
    );
    const pdfConfiguration: PdfConfiguration = {
      openPDF: open,
      downloadPDF: false,
      watermark: watermark,
      content: content,
    };
    return this.pdfGeneratorService.createPdf(pdfConfiguration, targetWindow);
  }

  async createPurchasePaymentContent(
    image: any,
    purchase: IPurchasesInvoices,
    paymentType: string,
    paymentDescription: string,
    paymentElements: any,
  ) {
    const layoutConfiguration =
      this.generateContentPdfService.createLayout('grey');
    const content: PdfContent[] = [
      {
        style: 'tableExample',
        table: {
          widths: ['*', '*', '*'],
          heights: [25, 25, 25],
          body: [
            [
              await this.generateContentPdfService.createPdfPaymentLogo(image),
              this.generateContentPdfService.createRowSpanObject(
                3,
                this.companyName,
              ),
              this.generateContentPdfService.createRowSpanObject(
                3,
                `Recibo\n ${purchase.contpurchase!.written_invoice}`,
              ),
            ],
            ['', '', ''],
            ['', '', ''],
          ],
        },
      },
      {
        style: 'tableExample',
        color: '#444',
        table: {
          widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto'],
          headerRows: 2,
          body: [
            [
              {
                style: 'header',
                border: [true, true, false, false],
                text: 'Recibimos de',
              },
              {
                style: 'textStyle',
                border: [false, true, true, true],
                colSpan: 3,
                text: `${purchase.provider.nombre}`,
              },
              {
                text: '',
              },
              {
                text: '',
              },
              { style: 'header', text: 'Fecha Recibo' },
              { style: 'header', text: 'Forma Pago' },
            ],
            [
              {
                style: 'header',
                border: [true, false, false, false],
                text: 'NIT',
              },
              {
                style: 'textStyle',
                border: [false, true, true, true],
                text: `${purchase.provider.doc_nit}`,
              },
              {
                style: 'header',
                border: [true, true, false, false],
                text: 'Telefono',
              },
              {
                style: 'textStyle',
                border: [false, true, true, true],
                text: `${purchase.provider.telefono}`,
              },
              { style: 'textStyle', text: `${purchase.createdAt}` },
              {
                style: 'textStyle',
                text: `${this.translate.instant(
                  paymentType,
                )} ${paymentDescription}`,
              },
            ],
            [
              {
                style: 'header',
                border: [true, false, false, true],
                text: 'Direccion',
              },
              {
                style: 'textStyle',
                border: [false, true, true, true],
                text: `${purchase.provider.direccion}`,
              },
              {
                style: 'header',
                border: [true, false, false, true],
                text: 'Ciudad',
              },
              {
                style: 'textStyle',
                border: [false, true, true, true],
                text: `${purchase.provider.city}`,
              },
              { style: 'header', text: '-' },
              { style: 'textStyle', text: `` },
            ],
          ],
        },
        layout: layoutConfiguration,
      },
      {
        style: 'tableExample',
        table: {
          widths: ['*', 'auto'],
          body: [
            [
              { style: 'header', text: 'El valor de' },
              { style: 'textStyle', text: `${purchase.purchases[0].total}` },
            ],
          ],
        },
        layout: layoutConfiguration,
      },
      {
        style: 'tableExample',
        table: {
          widths: [70, 70, 70, '*', 'auto'],
          body: paymentElements,
        },
        layout: layoutConfiguration,
      },
      {
        style: 'tableExample',
        table: this.generateContentPdfService.createPaymentObservations(),
        layout: layoutConfiguration,
      },
      {
        style: 'tableExample',
        table: this.generateContentPdfService.createPaymentSign(),
        layout: layoutConfiguration,
      },
    ];
    return content;
  }
}
